import * as htmx from 'htmx.org';


// Maintain the current scroll position when the new content is loaded in,
// this seems like generally desirable behaviour to avoid too much shifting about;
let scrollPos = window.scrollY;

htmx.on( 'htmx:beforeSwap', function( event ) {
    scrollPos = window.scrollY;
} );

htmx.on( 'htmx:afterSwap', function( event ) {
    window.scrollTo( {
        top: scrollPos,
        behavior: 'instant'
    } );
} );
